import React from "react";
import Navigation from "../../dashboard/navigation.jsx";

import ProductFilter from "./ProductFilter.jsx";
import { ProductsProvider } from "./products.context.jsx";
import ProductsList from "./ProductsList.jsx";
import ProductPagination from "./ProductPagination.jsx";

export const Products = () => {
  return (
    <ProductsProvider>
      <div className="cell auto products-body body-white">
        <div className="grid-container">
          <div className="grid-x">
            <Navigation heading="Manage Products" />
            <div className="cell small-12">
              <ProductFilter />
              <ProductsList />
              <ProductPagination />
            </div>
          </div>
        </div>
      </div>
    </ProductsProvider>
  );
};

export default Products;
